import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Observable,of } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class StockingPaceServiceService {
  getToken = () => localStorage.getItem('Token');
  appJson = 'application/json';

  getBusinessEntity = () => localStorage.getItem('namcvalue');

  getBusinessEntityName = () => localStorage.getItem('namcName');

  getUserRole = () => localStorage.getItem('UserRoles');

  getUserUPN = () => localStorage.getItem('UPN');

  getWorkID = () => localStorage.getItem('workdayId');

  getUserName = () => localStorage.getItem('UserName');
  getApiHeaders = () => {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: this.getToken(),
      'X-Api-Key': this.environment.stockingPaceKey,
      
    });
  };

  httpCustomOptions = () => {
    return {
      headers: new HttpHeaders({
        'Content-Type': this.appJson,
        Accept: this.appJson,
        Authorization: this.getToken(),
        'X-Api-Key': this.environment.stockingPaceKey,
        
      }),
    };
  };

  httpCustomOptions1 = () => {
    return {
      params: {
        business_entity: this.getBusinessEntity(),
        user_role: this.getUserRole(),
        workid: this.getWorkID(),
      },
      headers: this.getApiHeaders(),
    };
  };

  apiUrl = '';

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) {
    this.apiUrl = environment.moduleStockingPaceUrl;
  }
  app;

  getStockingPaceData(data): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/getInquire`, data, this.httpCustomOptions());
  }
  getDockAndModuleType(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/getdockandmoduletype`, this.httpCustomOptions1()).pipe(catchError(error => of({ error })))
  }
  getVanMonth(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/getvanningmonth`, this.httpCustomOptions1());
  }
  editStockingPaceData(data): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/editstockingpace`, data, this.httpCustomOptions());
  }

  //maintenance screen
  getMaintenanceModuleType(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/getModule`, this.httpCustomOptions1());
  }

  getStockingPaceMaintenanceData(data): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/getMaintenance`, data, this.httpCustomOptions());
  }
  stokingEdit(data): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}/editMaintenance`, 
      data,
      this.httpCustomOptions()
    );
  }
  pitchBatchStatus(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/pitchBatchStatus`, 
      data,
      this.httpCustomOptions()
    );
  }
  excelDownloadFilter(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/exceldownloadfilter`,
      data,
      this.httpCustomOptions()
    );
  }
  downloadPaceData(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/downloadpacedata`,
      data,
      this.httpCustomOptions()
    );
  }
  uploadPaceData(data): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/uploadpacedata`,
      data,
      this.httpCustomOptions()
    );
  }
}
